import { useQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'
import type { ChatAiDraftPayload } from '../../sse/types'

export const useQueryAiDraft = (roomId: string) => {
	return useQuery({
		queryKey: chatKeys.aiDraft(roomId),
		queryFn: () =>
			chatService.getLatestAiDraft(
				roomId,
			) as Promise<ChatAiDraftPayload | null>,
		enabled: !!roomId,
		staleTime: 60 * 1000,
		refetchOnMount: true,
	})
}
